import { useRef } from "react";
import { Camera } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ReceiptScanButtonProps {
  scanning: boolean;
  disabled?: boolean;
  label?: string;
  onFile: (file: File) => void;
}

export default function ReceiptScanButton({
  scanning,
  disabled,
  label = "Scan receipt",
  onFile,
}: ReceiptScanButtonProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={(e) => {
          const file = e.target.files?.[0];
          e.target.value = "";
          if (file) onFile(file);
        }}
      />
      <Button
        disabled={disabled}
        loading={scanning}
        onClick={() => inputRef.current?.click()}
      >
        {!scanning && <Camera className="w-4 h-4 mr-2" />}
        {scanning ? "Reading receipt…" : label}
      </Button>
    </>
  );
}
